var Acr = Acr || {};

import * as Constants from '../Constants';
import { IAcrGalleryDetail } from "../../interfaces/IAcrGalleryDetail";
import Packery from 'packery';

export function AcrGallery(element: HTMLElement) {
  let gallery: HTMLElement;
  let galleryGridElement: HTMLElement;
  let galleryGridPackery: Packery;
  let galleryItems: NodeListOf<HTMLElement>;
  let acrGalleryDetailArray: IAcrGalleryDetail[];
  let galleryDetailId: string[] | undefined;
  let isMiniGallery: boolean;
  let galleryMatchMedia: MediaQueryList;

  const galleryGridSelector = '.js-gallery-grid';
  const galleryItemSelector = '.js-gallery-item';
  const miniGalleryClassSelector = 'acr-gallery--mini';

  const initPackery = () => {
    galleryGridPackery = new Packery(galleryGridElement, {
      itemSelector: galleryItemSelector,
      gutter: 3,
      percentPosition: true,
    });
  }

  const initObjects = () => {
    galleryDetailId = gallery.dataset.galleryDetail ? gallery.dataset.galleryDetail.toString().split(',') : undefined;

    if (galleryDetailId !== undefined) {
      galleryDetailId.forEach(function (id) {
        // @ts-ignore
        var acrGalleryDetail = new window.Acr.GalleryDetail();
        var newGalleryDetail = document.getElementById(id);
        acrGalleryDetail.init(newGalleryDetail);
        acrGalleryDetailArray[id] = acrGalleryDetail;
      });
    }
  }

  const initSelectors = (element: HTMLElement) => {
    gallery = element;
    galleryGridElement = gallery.querySelector(galleryGridSelector);
    galleryItems = gallery.querySelectorAll(galleryItemSelector);
    isMiniGallery = gallery.classList.contains(miniGalleryClassSelector);
  }

  const initGlobalVariables = (element: HTMLElement) => {
    gallery = element;
    isMiniGallery = gallery.classList.contains(miniGalleryClassSelector);
    acrGalleryDetailArray = [];
  }

  const openGalleryDetail = () => {
    if (galleryDetailId !== undefined) {
      galleryItems.forEach(item => {
        item.addEventListener('click', function (e) {
          e.preventDefault();

          var target = (e.target as HTMLElement).closest('.js-gallery-item');
          var detailTargetId = (target as HTMLElement).dataset.galleryDetailTarget;
          var imageId = (target as HTMLElement).dataset.imageId;
          var index = (target as HTMLElement).dataset.index;
          if (detailTargetId) {
            acrGalleryDetailArray[detailTargetId].openDetailview(imageId, index, isMiniGallery);
          }
        });
      })
    }
  }

  const reset = () => {
    // disable transition
    galleryGridPackery.options.transitionDuration = '0s';
    galleryGridPackery.layout();
    // re-enable transition
    galleryGridPackery.options.transitionDuration = '0.4s';
  }

  const reloadPackery = () => {
    setTimeout(function () {
      galleryGridPackery.layout();
    }, 200);
  }

  const bindEvents = () => {
    galleryMatchMedia.addEventListener('change', () => {
      reloadPackery();
    });
    openGalleryDetail();
  }

  const defineMatchMedia = () => {
    galleryMatchMedia = window.matchMedia('(max-width:' + (Constants.breakpoints.md - 1) + 'px)'); // max-width: 767px
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables(element);
    initObjects();
    initPackery();
    defineMatchMedia();
    bindEvents();
  }

  return {
    init: init,
    reset: reset,
  };
}
